function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.562054907142857 1.6715907857142858C12.42844227857143 1.4107930092857142 12.225444064285714 1.1919290914285714 11.975429871428572 1.0390992985714287 11.725415678571428 0.8862679135714285 11.438065735714286 0.8053997935714284 11.145047764285714 0.8053997935714284c-0.2930338928571428 0 -0.5803838357142858 0.08086811999999999 -0.8303980285714285 0.23369950499999997 -0.2500141928571428 0.15282979285714285 -0.4530124071428571 0.3716937107142857 -0.5866091142857143 0.6324914871428571l-8.756792082857142 17.513571428571428c-0.12213327857142857 0.24232414285714285 -0.18028152 0.5118739285714285 -0.16892317285714284 0.7831750714285715 0.011358347142857142 0.27114192857142855 0.09184753714285715 0.5348007857142857 0.23382369214285711 0.7661391428571429 0.14197456285714286 0.23133835714285717 0.34072334785714287 0.4225547142857143 0.5773762778571429 0.5553394285714286 0.23664019285714286 0.13294392857142856 0.5033241214285714 0.20315742857142854 0.7747367142857142 0.20395349999999998H19.901785714285715c0.27146035714285716 -0.0007960714285714285 0.5381442857142857 -0.07100957142857142 0.7747367142857142 -0.20395349999999998 0.23675164285714284 -0.13278471428571428 0.4354510714285714 -0.3240010714285714 0.5774702142857143 -0.5553394285714286 0.14185992857142857 -0.23133835714285717 0.22242235714285713 -0.4949972142857143 0.23372657142857145 -0.7661391428571429 0.01146342857142857 -0.27130114285714285 -0.046808999999999996 -0.5408509285714286 -0.16892635714285714 -0.7831750714285715l-8.75673795 -17.513571428571428Z",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.145 7.960714285714285v5.1744642857142855",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 2605"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.145 17.513571428571428c-0.21982716428571428 0 -0.39803571428571427 -0.1781607857142857 -0.39803571428571427 -0.39803571428571427s0.17820855 -0.39803571428571427 0.39803571428571427 -0.39803571428571427",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 1112",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.145 17.513571428571428c0.21982716428571428 0 0.39803571428571427 -0.1781607857142857 0.39803571428571427 -0.39803571428571427s-0.17820855 -0.39803571428571427 -0.39803571428571427 -0.39803571428571427",
  strokeWidth: 2
})));

function SvgWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.855 -0.855 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning_triangle.ee69f4cd.svg";
export { ForwardRef as ReactComponent };